// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IPatientRegistrationData {
    static getAttributeTypeMap() {
        return IPatientRegistrationData.attributeTypeMap;
    }
}
IPatientRegistrationData.discriminator = undefined;
IPatientRegistrationData.additionalProperties = false;
IPatientRegistrationData.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "userId",
        "baseName": "userId",
        "type": "number"
    },
];
//# sourceMappingURL=iPatientRegistrationData.js.map